<form [formGroup]="configurationFormGeneral">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="configurationName" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.name' | translate}}</label>
      <input id="configurationName" type="text" class="form-control" formControlName="configurationName" />
      <app-error-messages [control]="configurationFormGeneral.get('configurationName')"></app-error-messages>
    </div>
    @if (isTemplateMode()) {
      <div class="form-group col-md-4">
        <label class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.mode' | translate}}</label>
        <app-button-group id="mode"
          [fieldsEnum]="ExportInterfaceConfigurationMode"
          [isNumericEnum]="true"
          formControlName="mode"
          [translateKey]="'i18n.domain.export-configuration.configurations.enums.mode.'">
        </app-button-group>
      </div>
    }
    <div class="form-group col-md-4">
      <label for="description" class="control-label">
        {{'i18n.domain.export-configuration.configurations.forms.general.form-fields.description' | translate}}
      </label>
      <input id="description" type="text" class="form-control" formControlName="description" />
      <app-error-messages [control]="configurationFormGeneral.get('description')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.type' | translate}}</label>
      <app-enum-drop-down-list formControlName="type"
                               [showClearButton]="false"
                               [enumType]="Type"
                               [excludeEnumMembers]="excludeTypeEnumMembers"
                               baseTranslationString='i18n.shared.configurationTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormGeneral.get('type')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.transfer-type' | translate}}</label>
      <app-enum-drop-down-list id="transferType" formControlName="transferType" [showClearButton]="false" [enumType]="TransferType" [excludeEnumMembers]="excludeTransferTypeEnumMembers"
        baseTranslationString='i18n.shared.transferTypes.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormGeneral.get('transferType')"></app-error-messages>
    </div>
    @if (!isTemplateMode()) {
      <div class="form-group col-md-4">
        <label class="control-label">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.active' | translate}}</label>
        <app-yes-no-group-button id="active"
                                 formControlName="active"
                                 i18nTranslationKeyPrefix="i18n.domain.export-configuration.configurations.yes-no-fields.active">
        </app-yes-no-group-button>
        <app-error-messages [control]="configurationFormGeneral.get('active')"></app-error-messages>
      </div>
    }
    @if (showActivationEmailOption) {
      <div class="form-group col-md-4">
        <label class="control-label">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.activation-email-template' | translate}}</label>
        <div [ngClass]="{'d-flex': showEmailPreviewButton}">
          <ejs-dropdownlist #activationEmailTemplateId
                            formControlName="activationEmailTemplateId"
                            popupWidth="auto"
                            [showClearButton]="true"
                            [dataSource]="activationEmailTemplates"
                            [fields]="fields">
          </ejs-dropdownlist>
          @if (showEmailPreviewButton) {
            <button type="button" class="ms-1 btn btn-outline-secondary" [disabled]="!enablePreviewButton" (click)="loadEmailPreview()">
              {{'i18n.domain.export-configuration.configurations.forms.general.form-fields.activation-email-preview' | translate}}
            </button>
          }
          <app-error-messages [control]="configurationFormGeneral.get('activationEmailTemplateId')"></app-error-messages>
        </div>
      </div>
    }
    @if (showActivationEmailOption && showEmailPreviewButton) {
      <div class="form-group col-md-4">
        <label for="activationEmailLastSentOn" class="control-label">{{'i18n.domain.export-configuration.configurations.forms.general.form-fields.activation-email-last-sent-on' | translate}}</label>
        <input id="activationEmailLastSentOn"
               type="text"
               class="form-control"
               formControlName="activationEmailLastSentOn" />
        <app-error-messages [control]="configurationFormGeneral.get('activationEmailLastSentOn')"></app-error-messages>
      </div>
    }
  </div>
</form>
@if (showUserAccessList) {
  <div class="form-row row">
    <div class="col-md-8">
      <label>
        {{'i18n.domain.export-configuration.configurations.forms.general.grid.email-title' | translate}}
      </label>
      <app-configuration-access></app-configuration-access>
    </div>
  </div>
}
<app-activation-email-preview [generatedActivationEmails]="activationEmails"
                              [showPreview]="showPreview"
                              [sendAllowed] = "sendActivationEmailAllowed"
                              (previewClosed)="onPreviewClosed()"
                              (sendEmailClicked)="onSendEmailClickd($event)"
                              (sendAllEmailClicked)="onsendAllEmailClicked($event)">
</app-activation-email-preview>
